import YouTube from 'react-youtube';
import classNames from 'classnames';

import styles from './Video.module.scss';

const Video = ({ video: { title = '', videoId = '' }, className = '' }) => {
  return (
    <div
      className={classNames([styles.wrap, { [styles.show]: true }, className])}
      itemScope
      itemType='http://schema.org/VideoObject'
    >
      {!!title && <div className={styles.title}>{title}</div>}
      {/* {!!videoTime && (
        <div className={styles.time}>{formatTime(videoTime)}</div>
      )} */}
      {/* <img
        className={styles.img}
        src={hasHttp ? preview : generateImageUrl(preview, true)}
        alt='youtube preview'
        loading="lazy"
      /> */}

      {!!videoId && <YouTube className={styles.frame} videoId={videoId} />}
      {/* <div className={styles.playIcon} onClick={() => setVideoShow(true)}>
        {icon || (
          <div className={styles.play}>
            <Play />
          </div>
        )}
      </div> */}
    </div>
  );
};

export default Video;
